import React from "react";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Paper,
  FormControlLabel,
  Switch
} from "@mui/material";
import { useEffect, useState } from "react";
import { authenticationService } from "src/services/authentication.service";
import { get } from "src/services/httpClient.service";

const BroadcasterReports = () => {

  //broadcaster states
  const [broadcasters, setBroadcasters] = useState([]);
  const [selectedBroadcaster, setSelectedBroadcaster] = useState("");

  const { vendorId } = authenticationService.getVendorFranchiseIds();

  const fetchBroadcasters = async () => {
  try {
    const response = await get(
      `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_BROADCASTER}/${vendorId}`
    );

    setBroadcasters(response?.data || []);
  } catch (error) {
    console.error("Failed to fetch broadcasters:", error);
  }
};

useEffect(() => {
  fetchBroadcasters();
}, []);
  
  return (
    <Box p={3}>
      <Paper elevation={3} sx={{ p: 3 }}>
        {/* Header */}
        <Typography
          variant="h6"
          sx={{
            mb: 3,
            p: 1,
            backgroundColor: "green",
            color: "#fff",
            fontWeight: "bold"
          }}
        >
          Monthly Subscription Package AlaCarte Report
        </Typography>

        <Grid container spacing={2}>
          {/* Row 1 */}
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              label="Export To *"
              defaultValue="PDF"
            >
              <MenuItem value="PDF">PDF</MenuItem>
              <MenuItem value="Excel">Excel</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Date 1 *"
              type="datetime-local"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Date 2 *"
              type="datetime-local"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Date 3 *"
              type="datetime-local"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Row 2 */}
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Date 4 *"
              type="datetime-local"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              label="Service Type *"
              defaultValue="PAYTV"
            >
              <MenuItem value="PAYTV">PAYTV</MenuItem>
              <MenuItem value="OTT">OTT</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
  select
  fullWidth
  label="Broadcaster"
  value={selectedBroadcaster}
  onChange={(e) => setSelectedBroadcaster(e.target.value)}
>
  <MenuItem value="">
    All Broadcasters
  </MenuItem>

  {broadcasters.map((item) => (
    <MenuItem key={item.id} value={item.id}>
      {item.name}
    </MenuItem>
  ))}
</TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select fullWidth label="Phase" defaultValue="ALL">
              <MenuItem value="ALL">All Phase</MenuItem>
            </TextField>
          </Grid>

          {/* Row 3 */}
          <Grid item xs={12} md={3}>
            <TextField select fullWidth label="Provider">
              <MenuItem value="">All Provider</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select fullWidth label="Market Name">
              <MenuItem value="">All Market Name</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select fullWidth label="City">
              <MenuItem value="">Select City</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select fullWidth label="Area">
              <MenuItem value="">Select Area</MenuItem>
            </TextField>
          </Grid>

          {/* Row 4 */}
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              label="Report Type"
              defaultValue="DETAILS"
            >
              <MenuItem value="DETAILS">Details</MenuItem>
              <MenuItem value="SUMMARY">Summary</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControlLabel
              control={<Switch defaultChecked />}
              label="Show Zero Count"
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              label="Header Type"
              defaultValue="WITH"
            >
              <MenuItem value="WITH">With Header</MenuItem>
              <MenuItem value="WITHOUT">Without Header</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        {/* Button */}
        <Box mt={3}>
          <Button variant="contained" color="primary">
            Get Report
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default BroadcasterReports;